<template>
    <div class="tree-menu">
        <div class="label-wrapper">
            <div :style="indent" :class="labelClasses" class="row justify-content-between">
                <div>
                    <i v-if="children && children.length > 0" @click="toggleChildren" class="fas spread pr-3" :class="iconClasses"></i>
                    <span @click="toggleSelectionOfItem" :class="deactivated ? 'text-danger' : ''">
                        {{ name }}
                    </span>
                </div>
                <button v-if="editMode" type="button" class="btn btn-link m-0 p-0" @click.stop="editItem()">
                    <i class="far fa-edit text-success"></i>
                </button>
            </div>
        </div>
        <div v-if="showChildren">
            <TreeMenu
                v-for="child in children"
                :children="child.children"
                :name="child.name"
                :deactivated="child.deactivated"
                :depth="depth + 1"
                :id="child.id"
                :key="child.id"
                :editMode="editMode"
                @update-active="updateActive"
                @show-edit-modal="showEditModal"
            >
            </TreeMenu>
        </div>
    </div>
</template>

<script>
    import TreeMenu from "@/components/help/TreeMenu";
    import bus from '../../components/sidemenu/event-bus';
    import { mapGetters } from 'vuex';

    export default {
        name: 'TreeMenu',
        props: [ 'children', 'name', 'depth', 'id', 'deactivated', 'editMode' ],
        components: {
            TreeMenu,
        },
        data() {
            return {
                showChildren: false,
                selected: false,
            }
        },
        computed: {
            ...mapGetters(['claims']),
            hasEditRights() {
                return this.claims.help.update;
            },
            iconClasses() {
                return {
                    'fa-caret-right': !this.showChildren,
                    'fa-caret-down': this.showChildren
                }
            },
            labelClasses() {
                return {
                    'has-children': this.children,
                    'selected': this.selected
                 }
            },
            indent() {
                return {
                    transform: `translate(${this.depth * 30}px)`,
                    width: `calc(100% - ${this.depth * 30 - 26}px)`
                }
            }
        },
        methods: {
            toggleChildren() {
                this.showChildren = !this.showChildren;
            },
            toggleSelectionOfItem() {
                this.selected = !this.selected;
                if (this.selected) {
                    bus.$emit('UNSELECT_ITEMS', this.id);
                    this.$emit('update-active', this.id);
                } else {
                    this.$emit('update-active', undefined);
                }
            },
            updateActive(active) {
                this.$emit('update-active', active);
            },
            editItem() {
                this.$emit('show-edit-modal', this.id);
            },
            showEditModal(id) {
                this.$emit('show-edit-modal', id);
            }
        },
        mounted() {
            const self = this;
            bus.$on('UNSELECT_ITEMS', function (itemId) {
                if (self.id !== itemId) {
                    self.selected = false;
                }
            });
        }
    }
</script>

<style lang="scss" scoped>
    body {
        font-family: "Open Sans", sans-serif;
        font-size: 18px;
        font-weight: 300;
        line-height: 1em;
    }

    .container {
        width: 300px;
        margin: 0 auto;
    }

    .tree-menu {

    .label-wrapper {
        padding-bottom: 10px;
        margin-bottom: 10px;
        margin-left: 12px;
        border-bottom: 1px solid #ccc;
    }

    .spread {
        cursor: pointer;
    }

    .selected {
        background-color: #eee;
    }

    .label-wrapper {
        div {
            width: 80%;
        }
    }

    .label-wrapper {
        div{
            div {
                padding-top: 8px;
            }
        }
    }
}
</style>
